import * as React from "react";
import {CrudPage} from "../crud/CrudPage";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {CrudList} from "../crud/CrudList";
import {Input} from "../form/fields/Input";
import {Field} from "../form/Field";
import {BooleanRadios} from "../form/fields/BooleanRadios";
import {Select} from "../form/fields/Select";
import {enumFormatter, getEnumOptions} from "../../utils/helper";
import {enums} from "../../Enums";
import {Textarea} from "../form/fields/Textarea";
import {api} from "../../api";
import {Col, Row, Container} from "reactstrap";
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export class CheckListFormData {
    @observable title = null;
    @observable type = null;
    @observable sub_type = null;
    @observable is_active = true;
    @observable description = null;
    @observable entry_type = null;
    @observable order_no: number | null = null;
}

export class CheckListForm extends CrudForm {

    modelName = 'CheckList';

    @observable pu_order_no: number = 0;
    @observable collation_order_no: number = 0;

    constructor(props: any) {
        super(props);
        this.onKeyPress = this.onKeyPress.bind(this);
    }

    loadMoreData(props: any, module: any) {
        this.getMaxOrderNumber();
    }

    onKeyPress = (value: any) => {
        const validate = /^[0-9\b]+$/;
        if (!validate.test(value) && value) {
            this.formStore.setValue('order_no', Number(value.substring(0, value.length - 1)));
        }

        if (this.formStore.getValue('type') == 'polling_unit' && this.formStore.getValue('order_no') > this.pu_order_no) {
            this.formStore.setValue('order_no', Number(this.pu_order_no));
        }
        
        if (this.formStore.getValue('type') == 'collation' && this.formStore.getValue('order_no') > this.collation_order_no) {
            this.formStore.setValue('order_no', Number(this.collation_order_no));
        }
    };

    getMaxOrderNumber() {
        api.checkList.getMaxOrderNumberAction().then((data: any) => {
            this.collation_order_no = Number(data.collation_order_no);
            this.pu_order_no = Number(data.pu_order_no);
        });
    };

    renderFields() {
        return (
            <>
                <Field
                    label="Title"
                    name="title"
                    component={Input}
                    required={true}
                    store={this.formStore}
                    onChange={() => {
                        this.formStore.setValue('entry_type', null);
                    }}
                />

                <Field
                    name="type"
                    placeholder="Select type"
                    component={Select}
                    options={getEnumOptions(enums.checkListType)}
                    store={this.formStore}
                    onChange={(value: any) => {
                        this.formStore.setValue('entry_type', null);
                        this.onKeyPress(this.formStore.getValue('order_no'));
                        if (!this.id && value == "polling_unit") {
                            this.formStore.setValue('order_no', this.pu_order_no);
                        }
                        if (!this.id && value == "collation") {
                            this.formStore.setValue('order_no', this.collation_order_no);
                        }
                    }}
                />

                <Field
                    name="sub_type"
                    placeholder="Select sub type"
                    component={Select}
                    options={getEnumOptions(enums.checkListSubType)}
                    store={this.formStore}
                />

                {
                    this.formStore.getValue('sub_type') === 'entry' && this.formStore.getValue('type') === 'polling_unit' ?
                        <Field
                            name="entry_type"
                            placeholder="Select entry type"
                            component={Select}
                            options={getEnumOptions(enums.checkListEntryType)}
                            store={this.formStore}
                        />

                        : ''
                }

                <Field
                    name="description"
                    placeholder="Description"
                    component={Textarea}
                    required={true}
                    store={this.formStore}
                />

                <Field
                    type="number"
                    label="Display Order"
                    name="order_no"
                    component={Input}
                    required={true}
                    store={this.formStore}
                    min="0"
                    onChange={this.onKeyPress}
                />

                <Field
                    name="is_active"
                    component={BooleanRadios}
                    trueLabel="Active"
                    falseLabel="In-Active"
                    store={this.formStore}
                />
            </>
        );
    }
}

export class CheckListFilterForm {
    @observable type = null;
    @observable sub_type = null;
}

export class CheckListList extends CrudList {
    modelName = 'CheckList';

    colums() {
        return [
            {
                name: "title",
                label: "Title",
            },

            {
                name: "type",
                label: "Type",
                formatter: enumFormatter(enums.checkListType)
            },
            {
                name: "sub_type",
                label: "Sub Type",
                formatter: enumFormatter(enums.checkListSubType)
            },
            {
                name: "entry_type",
                label: "Entry Type",
                formatter: enumFormatter(enums.checkListEntryType)
            },
        ];
    }

    idColumn() {
        return '';
    }

    renderFilters() {
        return (

            <Container>
            <Row className="form-row">
                    <Col md={5}>
                        <ToastContainer autoClose={5000} />
                    </Col>
            </Row>
            <Row className="form-row">

                <Col md={3}>
                    <Field
                        name="type"
                        placeholder="Select type"
                        component={Select}
                        options={getEnumOptions(enums.checkListType)}
                        store={this.filterFormStore}
                    />
                </Col>
                <Col md={3}>
                    <Field
                        name="sub_type"
                        placeholder="Select sub type"
                        component={Select}
                        options={getEnumOptions(enums.checkListSubType)}
                        store={this.filterFormStore}
                    />
                </Col>
                <Col md={3} className="grid-search">
                    {this.renderSearch()}
                </Col>
            </Row>
            </Container>
            
        );
    }
}

export class CheckListPage extends CrudPage {
    modelName = 'CheckList';
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/CheckListPage.tsx